import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { FooterComponent } from './layout/footer/footer.component';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Logo } from './scripts/load-logo.script';
import { MatIconModule, MatButtonModule, MatProgressSpinnerModule, MatProgressBarModule } from '@angular/material';
import { IconAnimationDirective } from './directives/icon-animation.directive';
import { Loader } from './shared/loader/loader.component';
import { ProgressComponent } from './shared/progress/progress.component';
import { ProgressService } from './shared/progress/progress.service';
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    TopbarComponent,
    IconAnimationDirective,
    ProgressComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule
  ],
  providers: [Logo, ProgressService],
  bootstrap: [AppComponent]
})
export class AppModule { }
